import { useId, type ReactNode, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "id"> {
  label: string;
  hint?: ReactNode;
  /** Renders the field in the mono type role, for SQL and pasted DDL. */
  mono?: boolean;
}

export function Textarea({ label, hint, mono = false, className, ...props }: TextareaProps) {
  const id = useId();
  return (
    <div className="flex min-h-0 flex-col gap-2">
      <label htmlFor={id} className="type-label text-ink">
        {label}
      </label>
      <textarea
        id={id}
        aria-describedby={hint ? `${id}-hint` : undefined}
        className={cn(
          "w-full rounded-element bg-card text-ink border border-border p-3",
          "placeholder:text-ink-disabled resize-y",
          "hover:border-border-emphasized focus:border-accent",
          "transition-[border-color] motion-fast",
          mono ? "type-code" : "type-body",
          className,
        )}
        {...props}
      />
      {hint ? (
        <p id={`${id}-hint`} className="type-support text-ink-secondary">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
